import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterSearchDataSetComponent } from './filter-search-data-set.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FormDataSetModule } from '../form-data-set';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    FilterSearchDataSetComponent
  ],
  exports: [
    FilterSearchDataSetComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    CardComponent,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    FormDataSetModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatOptionModule,
    MatTooltipModule,
    MatListModule
  ]
})
export class FilterSearchDataSetModule { }
